import { LoaderFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api";
import { ManageCourseUpdateLectureLoaderDTO } from "../types/manageCourseLoaderTypes";

export async function ManageCourseUpdateLectureLoader({
  params,
}: LoaderFunctionArgs): Promise<ManageCourseUpdateLectureLoaderDTO> {
  const lectureId = params.lectureId;
  if (!lectureId) {
    throw new Error("courseId parametresi eksik");
  }
  try {
    const result = await apiEndpoints.lecturerGetLectureContent(lectureId);
    if (!result.success) {
      throw new Error(result.message || "Kurs içeriği yüklenemedi");
    }
    return result.data;
  } catch (error) {
    throw new Error("Kurs içeriği yüklenemedi");
  }
}
